const Constants = Object.freeze({
  // Backend communication
  REQUEST_IP_ADDRESS: `${window.location.origin}${process.env.PUBLIC_URL}/api/`,
  AUTH_STR: "f4610aa514477222afac2b77f971d069780ca2846f375849f3dfa3c0047ebbd1",

  // Browser storage and language selection
  WIFI_OR_ETHENET_KEY: "wifi-eth",
  LOCAL_STORAGE_KEY: "mn-eth-ip-language",
  ES_LANG_KEY: "es",
  EN_LANG_KEY: "en",
  PT_LANG_KEY: "pt",

  // Network interface modes and states
  CONNECTED_STATUS: "connected",
  DISCONNECTED_STATUS: "disconnected",
  DHCP_MODE: "dhcp",
  FIXED_IP_MODE: "fixedIp",
  ZERO_IP: "0.0.0.0",

  // Device and monitoring statuses
  OK: "ok",
  DIAGNOSTIC: "diagnostic",
  FAULT: "fault",
  ONLINE: "online",
  OFFLINE: "offline",
  NONE: "None",

  // Chart and visualization colors
  OK_CHART_COLOR: "#21BA45",
  DIAGNOSTIC_CHART_COLOR: "#FBBD08",
  FAULT_CHART_COLOR: "#DB2828",
  RED_HEX: "#f44336",
  YELLOW_HEX: "#fdd835",
  GREEN_HEX: "#00c853",
  PURPLE_HEX: "#ab47bc",
  BLUE_HEX: "#2185d0",
  ORANGE_HEX: "#F25C05",
  TEAL_HEX: "#38C7BD",
  GREY_HEX: "#404040",

  // Device capability values returned by the backend
  ATTR_SUPP_NOT_ANSWERED: 1,
  ATTR_SUP_FALSE: 2,
  ATTR_SUP_TRUE: 3,

  // Component layout scaling
  SCALING_FACTOR_LIVE_TOPOLOGY: 0.57,
  SCALING_FACTOR_DIAGNOSTIC: 0.48,
  SCALING_FACTOR_MEDIA_COUNTERS: 0.45,
  SCALING_FACTOR_LOG: 0.54,

  // Monitor update and NTP workflow
  GPG_FILE_EXTENSION: ".gpg",
  NOT_UPDATING: "notUpdating",
  UPDATE_FILES_FOUND: "updateFilesFound",
  FINISHED_UPDATING: "finishedUpdating",
  RESTARTING_MONITOR: "restartingMonitor",
  NTP_UPDATE_NOT_STARTED: "notUpdating",
  NTP_UPDATE_START: "start",
  NTP_UPDATE_SUCCESS: "sucess",
  NTP_UPDATE_FAIL: "fail",
  FILE_UPDATE_TYPE: "file-update",
  INTERFACE_CONFIG_UPDATE_TYPE: "interface-config-update",
  NTP_UPDATE_TYPE: "turnNtpOn",

  // Application metadata and report compliance
  TS_MONITOR_VERSION: "3.3.0",
  CONFORM: "conform",
  NON_CONFORM: "nonConform",
  CONFORM_W_RESTRICTION: "conformRestriction",

  // TS Expert error categories
  DUPLICATE_IP_ERROR_TYPE: "duplicatedIp",
  PING_ERROR_TYPE: "avgPingExceededLimit",
  DHCP_ERROR_TYPE: "dhcpConfigDetected",
  PACKET_LOSS_ERROR_TYPE: "packetLossLimitExceeded",
  INACTIVE_PORT_ERROR_TYPE: "inactivePort",
  NOT_IN_AUTONEGOTIATION_ERROR_TYPE: "portNotInAutonegotiation",
  NOT_IN_FULL_DUPLEX_ERROR_TYPE: "portNotInFullDuplex",
  INTERFACE_SPEED_ERROR_TYPE: "interfaceSpeedLessThan100",
  HARDWARE_FAULT_ERROR_TYPE: "portWithHardwareFault",
  ADDR_CONFLICT_ERROR_TYPE: "addressConflictDetected",
  FAULT_ERROR_TYPE: "fault",
  LOST_IP_ERROR_TYPE: "lostIp",
  MEDIA_COUNTERS_TYPE: "mediaCounters",
  ALIGNMENT_ERROR_TYPE: "alignmentErrorsNotZero",
  CARRIER_SENSE_ERROR_TYPE: "carrierSenseErrors",
  FCS_ERROR_TYPE: "fcsErrorsNotZero",
  SINGLE_COLLISION_ERROR_TYPE: "singleCollisionsNotZero",
  MULTIPLE_COLLISIONS_ERROR_TYPE: "multipleCollisionsNotZero",
  LATE_COLLISIONS_ERROR_TYPE: "lateCollisionsNotZero",
  EXCESSIVE_COLLISIONS_ERROR_TYPE: "excessiveCollisionsNotZero",
  SQE_TEST_ERROR_TYPE: "sqeTestErrorsNotZero",
  DEFERRED_TRANSMISSION_ERROR_TYPE: "deferredTransmissionNotZero",
  FRAME_TOO_LONG_ERROR_TYPE: "frameTooLongNotZero",
  MAC_TRANSMIT_ERROR_TYPE: "macTransmitErrorsNotZero",
  MAC_RECEIVE_ERROR_TYPE: "macReceiveErrorsNotZero",
  INTERFACE_COUNTERS_TYPE: "interfaceCounters",
  IN_DISCARDS_ERROR_TYPE: "inDiscardsNotZero",
  IN_ERRORS_ERROR_TYPE: "inErrorsNotZero",
  IN_UNKNOWN_PROTOS_ERROR_TYPE: "inUnknownProtosNotZero",
  OUT_DISCARDS_ERROR_TYPE: "outDiscardsNotZero",
  OUT_ERRORS_TYPE: "outErrorsNotZero",

  // Graphic topology assets
  SCANNER_OK_IMG_PATH: process.env.PUBLIC_URL + "/images/scanner-ok.png",
  SCANNER_OK_INCREMENT_ERROR_IMG_PATH: process.env.PUBLIC_URL + "/images/scanner-ok-increment-error.png",
  SCANNER_FAULT_INCREMENT_ERROR_IMG_PATH: process.env.PUBLIC_URL + "/images/scanner-fault-increment-error.png",
  SCANNER_FAULT_IMG_PATH: process.env.PUBLIC_URL + "/images/scanner-fault.png",
  DEVICE_OK_IMG_PATH: process.env.PUBLIC_URL + "/images/device-ok.png",
  DEVICE_OK_INCREMENT_ERROR_IMG_PATH: process.env.PUBLIC_URL + "/images/device-ok-increment-error.png",
  DEVICE_FAULT_INCREMENT_ERROR_IMG_PATH: process.env.PUBLIC_URL + "/images/device-fault-increment-error.png",
  DEVICE_FAULT_IMG_PATH: process.env.PUBLIC_URL + "/images/device-fault.png",
  SWITCH_IMG_PATH: process.env.PUBLIC_URL + "/images/switch.png",
  SWITCH_INCREMENT_ERROR_IMG_PATH: process.env.PUBLIC_URL + "/images/switch-increment-error.png",
  SWITCH_OK_IMG_PATH: process.env.PUBLIC_URL + "/images/switch-ok.png",
  SWITCH_OK_INCREMENT_ERROR_IMG_PATH: process.env.PUBLIC_URL + "/images/switch-ok-increment-error.png",
  SWITCH_FAULT_INCREMENT_ERROR_IMG_PATH: process.env.PUBLIC_URL + "/images/switch-fault-increment-error.png",
  SWITCH_FAULT_IMG_PATH: process.env.PUBLIC_URL + "/images/switch-fault.png",
  DRIVE_OK_IMG_PATH: process.env.PUBLIC_URL + "/images/drive-ok.png",
  DRIVE_OK_INCREMENT_ERROR_IMG_PATH: process.env.PUBLIC_URL + "/images/drive-ok-increment-error.png",
  DRIVE_FAULT_INCREMENT_ERROR_IMG_PATH: process.env.PUBLIC_URL + "/images/drive-fault-increment-error.png",
  DRIVE_FAULT_IMG_PATH: process.env.PUBLIC_URL + "/images/drive-fault.png",
  ACCESS_POINT_IMG_PATH: process.env.PUBLIC_URL + "/images/wireless.png",
  ACCESS_POINT_OK_IMG_PATH: process.env.PUBLIC_URL + "/images/wireless-ok.png",
  ACCESS_POINT_FAULT_IMG_PATH: process.env.PUBLIC_URL + "/images/wireless-fault.png",
  ALERT_IMG: process.env.PUBLIC_URL + "/images/alert-icon.png",
});

export default Constants;
